import { render } from "./EventDetails.vue?vue&type=template&id=8a6d98c2"
import script from "./EventDetails.vue?vue&type=script&lang=js"
export * from "./EventDetails.vue?vue&type=script&lang=js"
script.render = render

export default script